if (!customElements.get('scrolling-vibe')) {
  customElements.define(
    'scrolling-vibe',
    class ScrollingVibe extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.scrolling-vibe__track');
        if (!this.track) return;
        this.setDuration();
        this.resizeObserver = new ResizeObserver(() => this.setDuration());
        this.resizeObserver.observe(this.track);
        // Pause the marquee while off-screen. Class toggle only, never inline
        // styles, so the prefers-reduced-motion CSS rule keeps winning.
        this.io = new IntersectionObserver(([entry]) =>
          this.classList.toggle('is-offscreen', !entry.isIntersecting)
        );
        this.io.observe(this);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.io) this.io.disconnect();
      }

      setDuration() {
        const isMobile = window.innerWidth <= 768;
        const speed =
          parseFloat(isMobile ? this.dataset.speedMobile : this.dataset.speedDesktop) || 80;
        const halfWidth = this.track.scrollWidth / 2;
        if (halfWidth > 0 && speed > 0) {
          this.track.style.setProperty('--scrolling-vibe-duration', `${halfWidth / speed}s`);
        }
      }
    }
  );
}
